<template>
    <div id="index">
        <div class="pc">
            <toptab></toptab>
            <div class="navbar">
                <navbar :navbarIndex="0"></navbar>
                <history></history>
            </div>
        </div>
        <div class="mobile">
            <historym></historym>
        </div>
    </div>
</template>

<script>
import toptab from "@/components/toptab"
import navbar from "@/components/navbar"
import history from "@/components/history"
import historym from "@/components/historym"
export default {
    components: {
        toptab,
        navbar,
        history, 
        historym
    }
}
</script>

<style lang="less" >
    .navbar{
        display: flex;
    }
</style>